import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ThemeConstants, ThemeColors, KitFlexRow, CPLogo } from '@chargepoint/cp-toolkit';

const Container = styled(KitFlexRow)`
  justify-content: flex-start;
  align-items: center;
  background-color: ${ThemeColors.gray_10};
  height: 64px;
  padding-left: ${ThemeConstants.spacing.m}rem;
  padding-right: ${ThemeConstants.spacing.m}rem;
`;

function Header() {
  const { t } = useTranslation();
  return (
    <Container>
      <CPLogo width={176} t={t} />
    </Container>
  );
}

export default Header;
